module.exports = __webpack_public_path__ + "static/media/edu10.4b7dd397.jpg";